import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Modal, message } from 'antd'
import request from '../../../utils/request'
import './createGroupModal.less'

let flag = true
class CreateGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      name: '',
      visible: true,
      mark: false
    }
    this.inputRef = ''
  }

  async onOk() {
    if (!this.state.name) {
      this.setState({ error: '分组名称不能为空' })
      return
    }
    this.setState({ error: '' })
    try {
      const id = await request.post(`group/create-new-group?${request.qs({ groupName: this.state.name })}`)
      this.onClose({ id, name: this.state.name })
      message.success('添加成功')
    } catch (error) {
      message.error(error.message || '网络链接失败，请稍后再试')
      this.setState({ error: error.message })
    }
  }

  onClose(val) {
    this.setState({ visible: false })
    this.props.close(val || null)
  }

  operate() {
    this.inputRef && this.inputRef.addEventListener('compositionstart', () => { flag = false })
    this.inputRef && this.inputRef.addEventListener('compositionend', () => { flag = true })
    this.inputRef && this.inputRef.addEventListener('input', () => {
      setTimeout(() => {
        if (flag) {
          this.changeKeyWord(this.inputRef.value)
        }
      }, 10)
    })
  }

  // 选择数据关键词
  changeKeyWord(name) {
    this.setState({ name, mark: true })
  }

  renderInfo() {
    if (!this.state.error) {
      return <sapn className="txt-info" style={{ color: '#737a86' }}>创建分组后，即可为已监控的店铺或商品移动至该分组。在竞店概况或商品概况中，选中某个分组即可快速找到添加了该分组的店铺或商品。</sapn>
    }
    return <span className="txt-info" style={{ color: 'red' }}>{this.state.error}</span>
  }

  render() {
    if (!this.state.mark) {
      setTimeout(() => this.operate(), 0)
    }
    return (
      <Modal
        centered
        title="新增分组"
        className="card-container"
        visible={this.state.visible}
        width={600}
        onOk={this.onOk.bind(this)}
        onCancel={this.onClose.bind(this, '')}
        cancelText="取消"
        okText="确定"
      >
        <input
          maxLength="15"
          className="group-input"
          ref={ref => this.inputRef = ref}
          placeholder="请输入分组名称"
        />
        {this.renderInfo()}
      </Modal>
    )
  }
}
let div = document.createElement('div')
export default {
  show() {
    return new Promise((resolve, reject) => {
      div = document.createElement('div')
      document.body.appendChild(div)
      ReactDOM.render(<CreateGroup close={this.destory.bind(this, resolve, reject)} />, div)
    })
  },
  destory(resolve, reject, val) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div)
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div)
      resolve(val)
    }
  }
}
